import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=c0620f36&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=c0620f36&lang=scss&scoped=true&"
import style2 from "./Dashboard.vue?vue&type=style&index=2&id=c0620f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0620f36",
  null
  
)

export default component.exports